import { Checkbox, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@shigo-ui/ui';

export function DashboardDataTableSelectionHeaderCheckbox({
  checked,
  disabled,
  label,
  onCheckedChange,
}: {
  checked: boolean | 'indeterminate';
  disabled: boolean;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span className="inline-flex">
            <Checkbox
              checked={checked}
              disabled={disabled}
              aria-label={label}
              onCheckedChange={(next) => {
                if (disabled) return;
                onCheckedChange(next === true);
              }}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
